import { lazy } from 'react';

export const PushNotificationsPageLazy = lazy(
  () =>
    import(
      /* webpackPreload: true */
      /* webpackChunkName: "PushNotificationsPage" */
      '@/pages/push-notifications/PushNotificationsPage'
    ),
);
